export enum EducationEnum {
    NONE = 0,
    PRIMARY = 1,
    SECONDARY = 2,
    HIGH_SCHOOL = 3,
    BACHELORS = 4,
    MASTERS = 5,
    DOCTORATE = 6
}